import { useNavigate } from 'react-router-dom'
import { BodyText } from 'styling/Typography'
import { IMachineFuelLinkProps } from 'types/fuelConsumption.interface'
import { findFuelMachineByName } from './fuelConsumptionDemoData'
import { MachineLinkName } from './MachineFuelLink.styled'

export const MachineFuelLink = ({ name }: IMachineFuelLinkProps) => {
  const navigate = useNavigate()
  const machine = findFuelMachineByName(name)
  if (!machine) return <BodyText weight='bold' title='No fuel analytics page for this machine yet'>{name}</BodyText>
  return (
    <MachineLinkName
      title='Open fuel consumption record'
      onClick={(e) => {
        e.stopPropagation()
        navigate(`/fuel/machines/${machine.id}`)
      }}
    >
      {name}
    </MachineLinkName>
  )
}
